export default class Storage {
    static init() {
        try {
            localStorage.setItem('oldst-test', 1);
            localStorage.removeItem('oldst-test');

            this.storageType = localStorage;
        } catch (err) {
            this.storageType = sessionStorage;
        }
    }

    static setItem(key, value) {
        try {
            this.storageType.setItem(key, value);
        } catch (error) {
            if (error instanceof DOMException && error.name === 'QuotaExceededError') {
                console.warn('Storage quota exceeded, clearing old data...');

                // Clear specific large items that might cause quota issues
                const itemsToClear = ['apiError', 'apiRequest', 'persist:root'];

                itemsToClear.forEach(item => {
                    try {
                        if (this.storageType.getItem(item)) {
                            console.warn(`Clearing ${item} from storage due to quota issues`);
                            this.storageType.removeItem(item);
                        }
                    } catch (clearError) {
                        console.error(`Error clearing ${item}:`, clearError);
                    }
                });

                // Try setting the item again after clearing
                try {
                    this.storageType.setItem(key, value);
                } catch (retryError) {
                    console.error('Failed to set item even after clearing storage:', retryError);

                    // As last resort, try with sessionStorage
                    try {
                        sessionStorage.setItem(key, value);
                    } catch (sessionError) {
                        console.error('Failed to set item in sessionStorage as well:', sessionError);
                    }
                }
            } else {
                console.error('Error setting storage item:', error);
            }
        }
    }

    static getItem(key) {
        return this.storageType.getItem(key);
    }

    static removeItem(key) {
        this.storageType.removeItem(key);
    }
}

Storage.init();
